import moment from "moment";
import React, { useEffect } from "react";
import { useRef } from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import Loader from "../../component/Common/Loader";
import Pagination from "../../component/Pagination/Pagination";
import { routes } from "../../constants";
import { useForm } from "../../hooks/useForm";
import { deleteIcon, editIcon, searchIcon } from "../../icons";
import { getNotification } from "../../store/slice/notificationSlice";
import SendNotificationModal from "./SendNotificationModal";
import DatePicker from "react-datepicker";
import Button from "../../component/Common/Button";
import Input from "../../component/Common/Input";
import DeleteNotification from "./DeleteNotification";
import {
  SidebarComponent,
  defaultTimeZone,
} from "../../helpers/commonFunction";
import ViewImageModal from "../../component/Common/PageComponent/ViewImageModal";

const Notifications = () => {
  const dispatch = useDispatch();
  const params = useParams();
  const navigate = useNavigate();
  const { page_number } = params;
  const [pageN, setPageN] = useState(page_number - 1);
  const ref = useRef(false);

  const location = useLocation();
  const page = location?.state?.page;
  const value = location?.state?.value;

  const sideHeading = localStorage.getItem("sidebar_component");

  const { t } = useTranslation("common");

  const [imgZoom, setImgZoom] = useState(false);
  const [imgSrc, setImgSrc] = useState("");
  const [apiErr, setApiErr] = useState(false);

  const notifications = useSelector(
    (state) => state.notification.notificationList?.data
  );
  const notificationLoader = useSelector((state) => state.notification.loader);
  const notificationsCount = useSelector(
    (state) => state.notification.notificationList?.count
  );

  const initialFValues = {
    sendNotificationModal: false,
    sendNotificationModalData: false,
    deleteModal: false,
    deleteModalId: "",
    notification_type: value?.notification_type ? value?.notification_type : "",
    notification_date: value?.notification_date ? value?.notification_date : "",
  };

  const { errors, setErrors, values, setValues, handleInputChange } = useForm(
    initialFValues,
    true
  );

  useEffect(() => {
    if (ref.current) {
      navigate(`${routes.notifications}/page/1`);
      if (+pageN === 0) {
        const timer = setTimeout(() => {
          dispatch(
            getNotification({
              notification_type: values.notification_type,
              notification_date:
                values.notification_date &&
                moment(values.notification_date).format("YYYY-MM-DD"),
              noAuthority: (error) => {
                if (error) {
                  console.log("err", error);
                  setApiErr(true);
                } else {
                  setApiErr(false);
                }
              },
            })
          );
        }, 500);
        return () => clearTimeout(timer);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, values.notification_type, values.notification_date]);

  useEffect(() => {
    if (ref.current) {
      dispatch(
        getNotification({
          start: pageN,
          notification_type: values.notification_type,
          notification_date:
            values.notification_date &&
            moment(values.notification_date).format("YYYY-MM-DD"),
          noAuthority: (error) => {
            if (error) {
              console.log("err", error);
              setApiErr(true);
            } else {
              setApiErr(false);
            }
          },
        })
      );
    }
  }, [pageN]);

  useEffect(() => {
    dispatch(
      getNotification({
        start: (page - 1) * 10,
        notification_type: values.notification_type,
        notification_date:
          values.notification_date &&
          moment(values.notification_date).format("YYYY-MM-DD"),
        noAuthority: (error) => {
          if (error) {
            console.log("err", error);
            setApiErr(true);
          } else {
            setApiErr(false);
          }
        },
      })
    );
    ref.current = true;

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onPageChange = (page_number) => {
    if (ref.current) {
      setPageN(page_number);
    }
  };

  const sendNowNotificationHandler = (menu) => {
    setValues({
      ...values,
      sendNotificationModal: true,
      sendNotificationModalData: menu,
    });
  };

  const handleClose = () => {
    setValues({
      ...values,
      sendNotificationModal: false,
      sendNotificationModalData: "",
    });
  };

  const deleteModalHandler = (menu) => {
    setValues({ ...values, deleteModal: true, deleteModalId: menu.id });
  };

  const handleCloseDeleteModal = () => {
    setValues({ ...values, deleteModal: false, deleteModalId: "" });
  };

  return (
    <>
      <div className="project_edit_main_content">
        <div className="rolemanagement_project_btn_row_flex">
          <h2 className="project_subheading">{SidebarComponent()}</h2>
          {/* <h2 className="project_subheading">{sideHeading}</h2> */}
          <div className="creat_edit_project_btn_row">
            <Link
              to={routes.createNotification}
              state={{ page_number }}
              className="comman_btn ml-auto"
            >
              {t("common.create")}
            </Link>
          </div>
        </div>

        <div className="user_data_search_select_box_row">
          <div className="user_data_search">
            <Input
              inputClassName="user_data_search_input"
              type="search"
              placeholder={t("filter.search_type")}
              id="notification_type"
              name="notification_type"
              value={values.notification_type}
              onChange={handleInputChange}
            />
            <Button buttonClassName="user_data_search_btn" text={searchIcon} />
          </div>
          <div className="user_data_search h-35">
            <DatePicker
              isClearable={values.notification_date}
              placeholderText={`${t("table.sent_date")}`}
              selected={values.notification_date}
              onChange={(date) => {
                setValues({ ...values, notification_date: date });
              }}
              dateFormat={"dd/MM/yyyy"}
            />
          </div>
        </div>

        <>
          {notificationLoader ? (
            <Loader />
          ) : notifications?.length === 0 ? (
            <h2 className="ta_c c-grey">No results found</h2>
          ) : !notifications && apiErr ? (
            <h2 className="ta_c c-grey">You have no authority</h2>
          ) : (
            <div className="custom_data_table_content">
              <table className="custom_data_table">
                <thead className="custom_data_table_head">
                  <tr>
                    <th className="custom_data_table_heading">
                      {t("table.image")}
                    </th>
                    <th className="custom_data_table_heading">
                      {t("table.title")}
                    </th>
                    <th className="custom_data_table_heading">
                      {t("table.type")}
                    </th>
                    <th className="custom_data_table_heading">
                      {t("form.userRole")}
                    </th>
                    <th className="custom_data_table_heading">
                      {t("table.createdAt")}
                    </th>
                    <th className="custom_data_table_heading">
                      {t("table.updatedAt")}
                    </th>
                    <th className="custom_data_table_heading">
                      {t("table.send")}
                    </th>
                    <th className="custom_data_table_heading">
                      {t("table.sent_date")}
                    </th>
                    <th className="custom_data_table_heading">
                      {t("table.action")}
                    </th>
                  </tr>
                </thead>
                <tbody className="custom_data_table_body">
                  {notifications?.map((menu, i) => {
                    return (
                      <tr className="custom_data_table_row" key={menu.id}>
                        <td className="custom_data_table_item table_item">
                          <img
                            src={
                              menu.notification_type_image
                                ? process.env.REACT_APP_FILE_BASE_URL +
                                  "/" +
                                  menu.notification_type_image
                                : process.env.REACT_APP_FILE_BASE_URL +
                                  "/45/a30a40a1-510a-420a-bfb6-bedb974e15ed.png"
                            }
                            alt={"notification_type_image"}
                            className={`custom_data_table_img`}
                            onClick={() => {
                              setImgZoom(true);
                              setImgSrc(
                                menu.notification_type_image
                                  ? process.env.REACT_APP_FILE_BASE_URL +
                                      "/" +
                                      menu.notification_type_image
                                  : process.env.REACT_APP_FILE_BASE_URL +
                                      "/45/a30a40a1-510a-420a-bfb6-bedb974e15ed.png"
                              );
                            }}
                          />
                        </td>
                        <td className="custom_data_table_item table_item">
                          {menu?.notification_title}
                        </td>
                        <td className="custom_data_table_item table_item">
                          {menu.notification_type_name}
                        </td>
                        <td className="custom_data_table_item table_item">
                          {menu.role_display_name?.map((item) => item + ", ")}
                        </td>
                        <td className="custom_data_table_item table_item">
                          {menu.created_at &&
                            moment
                              .utc(menu.created_at, "YYYYMMDD HH:mm:ss")
                              .clone()
                              .tz(defaultTimeZone)
                              .format("DD/MM/YYYY, hh:mm A")}
                        </td>
                        <td className="custom_data_table_item table_item">
                          {menu.updated_at
                            ? moment
                                .utc(menu.updated_at, "YYYYMMDD HH:mm:ss")
                                .clone()
                                .tz(defaultTimeZone)
                                .format("DD/MM/YYYY, hh:mm A")
                            : "-"}
                        </td>
                        <td className="custom_data_table_item table_item">
                          <div className="custom_data_table_view_edit_btn_item_row">
                            {menu?.send_now === "0" ? (
                              <button
                                onClick={() => sendNowNotificationHandler(menu)}
                                className="custom_data_table_view_edit_item_btn hide_compoenent_btn w-fc"
                              >
                                {t("table.send")}
                              </button>
                            ) : (
                              "-"
                            )}
                          </div>
                        </td>
                        <td className="custom_data_table_item table_item">
                          {menu.notification_date
                            ? moment(menu.notification_date).format(
                                "DD/MM/YYYY"
                              )
                            : "-"}
                        </td>

                        <td className="custom_data_table_item custom_data_table_view_edit_item table_item">
                          <div className="custom_data_table_view_edit_btn_item_row">
                            {menu.send_now === "0" ? (
                              <div className="tooltip">
                                <Link
                                  to={`${routes.notifications}/edit/${menu.id}`}
                                  state={{
                                    menu,
                                    page_number,
                                    value: {
                                      notification_type:
                                        values?.notification_type,
                                      notification_date:
                                        values?.notification_date,
                                    },
                                  }}
                                  className="custom_data_table_view_edit_item_btn"
                                >
                                  {editIcon}
                                </Link>
                                <span className="tooltiptext">Edit</span>
                              </div>
                            ) : (
                              "-"
                            )}

                            <div className="tooltip">
                              <button
                                className="custom_data_table_view_edit_item_btn"
                                onClick={() => deleteModalHandler(menu)}
                              >
                                {deleteIcon}
                              </button>
                              <span className="tooltiptext">Delete</span>
                            </div>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
          {+notificationsCount > 0 && (
            <Pagination
              totalRecords={notificationsCount}
              onPageChange={onPageChange}
            />
          )}
        </>
        <DeleteNotification
          show={values.deleteModal}
          serviceDetail={values.deleteModalId}
          handleClose={handleCloseDeleteModal}
          setValues={setValues}
          values={values}
          page_number={page_number}
        />
        <SendNotificationModal
          show={values.sendNotificationModal}
          handleClose={handleClose}
          values={values.sendNotificationModalData}
          setValues={setValues}
          page_number={page_number}
        />
      </div>
      <ViewImageModal
        setImgZoom={setImgZoom}
        imgZoom={imgZoom}
        imgSrc={imgSrc}
      />
    </>
  );
};

export default Notifications;
